import { jsx } from '@amzn/shiv'
import { ctx } from '@/util/context'
import { fetchAlbumTracks } from './partyService'
import { PartyResultItem } from './PartyResultItem'
import { Icon } from '@/components/Icon'
import { navigateTo } from '@/router/router'
import { LoadingIndicator } from '@/components/LoadingIndicator'

const { errorHandler } = ctx('PartyAlbumPage')

export function PartyAlbumPage({ albumId }: { albumId: string }) {
    const container = (
        <div className="partyResults">
            <div className="partyLoading">
                <LoadingIndicator />
            </div>
        </div>
    )

    fetchAlbumTracks(albumId)
        .then(({ title, tracks }) => {
            container.innerHTML = ''
            container.append(
                <div className="albumHeader" onclick={() => navigateTo('/')}>
                    <Icon icon="caretLeft" />
                    <span className="albumTitle">{title}</span>
                </div>
            )
            tracks.forEach((track) => container.append(<PartyResultItem data={track} />))
        })
        .catch(errorHandler)

    return container
}
